export default __webpack_public_path__ + "static/media/arrow_down_black.244809a8.svg";